import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Header, Body, Footer } from '@calendly/ui/components/popup'
import { BodyText } from '@calendly/ui/components/typography'
import { useDispatch, useSelector } from 'react-redux'

import { patchDomainControl } from './actions'
import { ENABLE_DISABLE_DOMAIN_POPUP } from './constants'
import { isPopupOpenSelector, isLoadingActionPopupSelector, domainForPopupSelector } from './selectors'
import { closePopup, setDomainForPopup } from './slice'

export const EnableDomainControlPopup = () => {
  const dispatch = useDispatch()
  const domain = useSelector(domainForPopupSelector)
  const isPopupOpen = useSelector(isPopupOpenSelector(ENABLE_DISABLE_DOMAIN_POPUP))
  const loadingActionPopup = useSelector(isLoadingActionPopupSelector)
  const isDomainControlEnabled = domain?.enforced

  const onCloseClick = () => {
    dispatch(closePopup())
    dispatch(setDomainForPopup(null))
  }

  const onConfirmClick = () => {
    dispatch(patchDomainControl({
      uuid: domain.uuid,
      data: {
        enforced: !domain.enforced
      }
    }))
  }

  if (!isPopupOpen) {
    return null
  }

  return (
    <Popup
      isOpen
    >
      <Header title={
        isDomainControlEnabled
          ? I18n.t('publisher.organization_settings.domain_control.popups.disable_title')
          : I18n.t('publisher.organization_settings.domain_control.popups.enable_title')
      }
      />
      <Body>
        <BodyText data-testid="domain_enablement_popup_body">
          {
            isDomainControlEnabled
              ? I18n.t('publisher.organization_settings.domain_control.popups.disable_body', {
                domain: domain?.domain
              })
              : I18n.t('publisher.organization_settings.domain_control.popups.enable_body')
          }
        </BodyText>
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onCloseClick}
        >
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button
          decoration={isDomainControlEnabled ? 'danger' : 'primary'}
          loading={loadingActionPopup}
          onClick={onConfirmClick}
        >
          {
            isDomainControlEnabled
              ? I18n.t('publisher.organization_settings.domain_control.popups.disable_button')
              : I18n.t('publisher.organization_settings.domain_control.popups.enable_button')
          }
        </Button>
      </Footer>
    </Popup>
  )
}
